import { render, staticRenderFns } from "./SoftVersionImage.vue?vue&type=template&id=17d54e9d&scoped=true&"
import script from "./SoftVersionImage.vue?vue&type=script&lang=js&"
export * from "./SoftVersionImage.vue?vue&type=script&lang=js&"
import style0 from "./SoftVersionImage.vue?vue&type=style&index=0&id=17d54e9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d54e9d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17d54e9d')) {
      api.createRecord('17d54e9d', component.options)
    } else {
      api.reload('17d54e9d', component.options)
    }
    module.hot.accept("./SoftVersionImage.vue?vue&type=template&id=17d54e9d&scoped=true&", function () {
      api.rerender('17d54e9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/SoftVersionIcon/components/common/SoftVersionImage.vue"
export default component.exports